<template>
	<div class="right-pop">
	    <div class="right-pop-circle"></div>
	    <img src="//img.58cdn.com.cn/job/img/maggregation_pop.png" alt="气泡图片" class = "right-pop-img"/>
	    <div class="right-pop-con">
	      	<p class = "right-pop-text">您投递了<span>{{hasApplyNum}}</span>份简历</p>
	      	<p>投递5份以上机会更多哦~</p>
	    </div>
    </div>
</template>
<script type= 'text/javascript'>
import {mapState} from 'vuex';
export default{
	computed: {
		...mapState([
			'hasApplyNum'
		])
	}
};
</script>
<style lang="scss">
  @import  "../../assets/style/public.scss";
.right-pop{
	position:fixed;
	bottom:px2rem(300px);
	right:0;
	z-index:10;
	height:px2rem(104px);
	width:px2rem(367px);
	background: rgba(255,85,46,0.90);
	.right-pop-circle{
		position:absolute;
		left:px2rem(-52px);
		width:px2rem(52px);
		height:px2rem(104px);
		border-radius:50%;
		background:rgba(255,85,46,0.90);
		border-radius: 100px 0 0 100px;  
	}
	.right-pop-img{
		position:absolute;
		top:50%;
		left:px2rem(-20px);
		width:px2rem(74px);
		height:px2rem(74px);
		margin-top:px2rem(-37px);
	}
	.right-pop-con{
		margin: px2rem(15px) 0 0 px2rem(74px);
		vertical-align:middle;
		color:$white;
		font-size:px2rem(24px);
		line-height:px2rem(40px);
		.right-pop-text{
		font-size:$font-size;
		}
	}
}
</style>


// WEBPACK FOOTER //
// pop.vue?6e4469b2